import React, { useContext } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { UserContext } from 'src/contexts/userContext';
import { UserType } from 'src/interfaces/UserTypes';
import TicketList from './TicketList';
import TicketDetailPage from './TicketDetail';
import PartnerTicketDetail from './PartnerTicketDetail';

function Tickets() {
  const userCtx = useContext(UserContext);
  const isPartner = userCtx?.currentUser?.userType === UserType.partner;

  // The global ticket dashboard (list) is admin-only. Partners have no list
  // route here — they reach ticket detail from the per-installation Tickets
  // tab; a direct hit on /tickets bounces them home.
  return (
    <Routes>
      <Route
        index
        element={isPartner ? <Navigate to="/" replace /> : <TicketList />}
      />
      <Route
        path=":id"
        element={isPartner ? <PartnerTicketDetail /> : <TicketDetailPage />}
      />
    </Routes>
  );
}

export default Tickets;
